export default __webpack_public_path__ + "static/media/95fb16c1342e3cdb0bc5f6a71cfe91fd1579112822885.6ac0a107.webp";